// How the backup's conditions are shown in the notification centre: with the
// Settings icon, where the Backup card they open lives.

import type { NotificationPresenter } from "@/notifications/client";
import { fmtDateTime, qk } from "@/platform/client";
import { IconSettings } from "@/platform/ui";
import { BACKUP_NOTIFICATIONS } from "@/backup/model/constants.js";

export const backupNotifications: NotificationPresenter = {
  source: BACKUP_NOTIFICATIONS,
  icon: (_, size) => <IconSettings size={size} />,
  detail: (n, tz) => {
    if (n.meta == null || !("lastBackupAt" in n.meta)) return n.body;
    const at = n.meta.lastBackupAt;
    return typeof at === "string"
      ? `Last backup ${fmtDateTime(at, tz, { alwaysDate: true, withYear: true })}`
      : "No backup";
  },
  refreshes: [qk.backup.status],
};
